import { render, staticRenderFns } from "./fourSelectOne.vue?vue&type=template&id=2d5d6650&scoped=true"
import script from "./fourSelectOne.vue?vue&type=script&lang=js"
export * from "./fourSelectOne.vue?vue&type=script&lang=js"
import style0 from "./fourSelectOne.vue?vue&type=style&index=0&id=2d5d6650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d6650",
  null
  
)

export default component.exports